import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, COMPANY } from "../lib/api";

const SERVICES = ["IT Support", "Migration Assistance", "Call Center Setup", "IP PBX Setup", "Software Development", "Backup Solutions", "Security Assessment", "Trainings"];

export function Footer() {
  const [contact, setContact] = useState({ contact_email: "sales@genesisitsolution.com", contact_phone: "+1 (800) 555-0142", contact_address: "" });

  useEffect(() => {
    api.get("/content").then((r) => {
      if (r.data) setContact((c) => ({
        contact_email: r.data.contact_email || c.contact_email,
        contact_phone: r.data.contact_phone || c.contact_phone,
        contact_address: r.data.contact_address || "",
      }));
    }).catch(() => {});
  }, []);

  return (
    <footer className="border-t border-zinc-200 bg-zinc-50">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 sm:px-8 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3">
            <img src="/genesis-mark-v2.png" alt="Genesis IT Solution logo" className="h-10 w-auto" />
            <div className="flex flex-col leading-none">
              <span className="font-heading text-lg font-black tracking-tight">GENESIS</span>
              <span className="font-mono-label text-[9px] text-klein mt-1">IT Solution</span>
            </div>
          </div>
          <p className="mt-4 max-w-xs text-sm text-zinc-500">
            Your full-spectrum technology partner. Infrastructure, communications, software and security — done right.
          </p>
        </div>
        <div>
          <p className="font-mono-label text-[11px] text-zinc-400">Services</p>
          <ul className="mt-4 space-y-2.5">
            {SERVICES.slice(0, 5).map((s) => (
              <li key={s}><Link to="/services" className="text-sm text-zinc-600 hover:text-klein">{s}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono-label text-[11px] text-zinc-400">Company</p>
          <ul className="mt-4 space-y-2.5">
            <li><Link to="/who-we-are" className="text-sm text-zinc-600 hover:text-klein">Who we are</Link></li>
            <li><Link to="/tools" className="text-sm text-zinc-600 hover:text-klein">Software store</Link></li>
            <li><Link to="/lets-build" className="text-sm text-zinc-600 hover:text-klein">Let's build</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-mono-label text-[11px] text-zinc-400">Get in touch</p>
          <ul className="mt-4 space-y-2.5 text-sm text-zinc-600">
            {contact.contact_email && (
              <li><a href={`mailto:${contact.contact_email}`} data-testid="footer-email" className="hover:text-klein">{contact.contact_email}</a></li>
            )}
            {contact.contact_phone && (
              <li><a href={`tel:${contact.contact_phone.replace(/[^0-9+]/g, "")}`} data-testid="footer-phone" className="hover:text-klein">{contact.contact_phone}</a></li>
            )}
            {contact.contact_address && (
              <li data-testid="footer-address" className="whitespace-pre-line">{contact.contact_address}</li>
            )}
          </ul>
          <Link to="/lets-build" className="mt-5 inline-block bg-klein px-5 py-2.5 text-sm font-semibold text-white hover:bg-kleindark">
            Start a project
          </Link>
        </div>
      </div>
      <div className="border-t border-zinc-200 py-6">
        <p className="mx-auto max-w-7xl px-5 text-xs text-zinc-400 sm:px-8">© {new Date().getFullYear()} {COMPANY}. All rights reserved.</p>
      </div>
    </footer>
  );
}
